import { GenericResponse } from 'types/GenericResponse';
import { createAsyncAction } from 'utils/Redux';

const ns = 'UPDATE_WIDGET';

const asyncAction = createAsyncAction<GenericResponse>(ns);

const updateWidgetAction = {
  ...asyncAction,
};

export default updateWidgetAction;
